<template>
    <div class="card-body">
        <h4 class="text-muted text-center">
            {{$t('message.overview.message.ipFirewall')}}
        </h4>
        <div class="text-center">
            <v-text-field :label="$t('message.generics.message.ip')"
                          name="IP"
                          v-model="val.ip"
                          v-validate="'required'"
                          :error-messages="errors.collect($t('message.generics.message.ip'))"
                          @input="$emit('input', val)"></v-text-field>

            <app-select v-model="val.operacao"
                        :data-title="$t('message.generics.message.operation')"
                        :data-search="false"
                        :data-items="operations"
                        :error-messages="errors.collect($t('message.generics.message.operation'))"
                        :clearable="false"/>

            <v-textarea
                v-model="val.observacao"
                rows="4"
                maxlength="500"
                :label="$t('message.overview.message.observations')"
            ></v-textarea>
        </div>
    </div>
</template>

<script>
    import AppSelect from '@components/Select'
    import vModel from '@mixins/v-model'

    export default {
        components: {
            AppSelect,
        },

        data() {
            return {
                operations: [
                    {id: 'LIBERADO', label: this.$t('message.overview.message.cleared')},
                    {id: 'BLOQUEADO', label: this.$t('message.overview.message.blocked')},
                ],
            }
        },

        mounted() {
        },

        methods: {

            async validate() {
                await this.$validator.validateAll()

                if (this.$validator.errors.items.length !== 0)
                    return this.$emit('to-general-tab')

                this.$emit('valid')
            },

        },
        mixins: [vModel],

    }

</script>

<style lang="scss" scoped>
    @import "~@variables";

    .card-body {
        padding: 18px 50px 10px;

        .v-input {
            margin: 12px 0 10px 0;
        }


        .dates {
            display: flex;
            margin-bottom: 32px;

            .date {
                display: flex;
                flex-direction: column;
                align-items: center;
                flex: 1 0 auto;

                .datepicker-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 175px;
                    height: 55px;
                    padding: 0 15px;
                    border: $border-1;
                    border-radius: 4px;
                    font-weight: bold;
                    color: $grey-4;

                    .mdi {
                        font-size: 24px;
                    }

                    input {
                        color: $grey-4;
                    }
                }
            }
        }

        .segment {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            & > *:not(:first-child) {
                margin-top: 10px;
            }
        }
    }
</style>
